import React from 'react';
import type { SkillInfo } from '@/types/agent';

interface SkillTagProps {
  skill: SkillInfo;
  onRemove: () => void;
}

/**
 * 技能标签（输入框内显示已选技能）
 * 参考：智能体输入框选中 Skill 后，在输入区顶部以标签形式展示技能名称
 */
export const SkillTag: React.FC<SkillTagProps> = ({ skill, onRemove }) => {
  return (
    <div
      className="flex items-center shrink-0"
      style={{
        height: '24px',
        backgroundColor: '#2d2d2d',
        borderRadius: '8px',
        padding: '0 8px',
        gap: '6px',
      }}
    >
      <img
        src="/icons/skill-picker/skill.svg"
        alt=""
        width={14}
        height={14}
        style={{ objectFit: 'contain', flexShrink: 0 }}
        draggable={false}
      />
      <span
        style={{
          fontSize: '13px',
          color: '#ffffff',
          fontFamily: '"PingFang SC", sans-serif',
          lineHeight: '14px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '160px',
        }}
      >
        {skill.name}
      </span>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        title="移除技能"
        style={{
          width: '14px',
          height: '14px',
          borderRadius: '3px',
          border: 'none',
          background: 'transparent',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          flexShrink: 0,
          opacity: 0.65,
          transition: 'opacity 0.15s ease',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.65')}
      >
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L9 9M9 1L1 9" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
};
